import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { WorkerPool } from "types/generated";
import useCanUpdateWorkerPool from "shared/WorkerPool/access/useCanUpdateWorkerPool";

type WorkerPoolUpdateActionProps = {
  onAction: () => void;
  workerPool: WorkerPool;
};

const WorkerPoolUpdateAction = ({ onAction, workerPool }: WorkerPoolUpdateActionProps) => {
  const canUpdateWorkerPool = useCanUpdateWorkerPool()(workerPool);

  const getTooltip = () => {
    if (!canUpdateWorkerPool.result) {
      return canUpdateWorkerPool.message;
    }
    return null;
  };

  const isDisabled = !canUpdateWorkerPool.result;
  const tooltip = getTooltip();

  return (
    <DropdownMenuItem
      tooltip={tooltip}
      isTooltipActive={!!tooltip}
      tooltipWidthMode="maxWidthSm"
      tooltipPlacement="left"
      onAction={onAction}
      isDisabled={isDisabled}
    >
      Edit
    </DropdownMenuItem>
  );
};

export default WorkerPoolUpdateAction;